(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-timeline')) {
    customElements.define('shipping-timeline', class extends HTMLElement {
    connectedCallback() {
      const orderedNode = this.querySelector('[data-shipping-date="ordered"]');
      const readyNode = this.querySelector('[data-shipping-date="ready"]');
      const deliveredNode = this.querySelector('[data-shipping-date="delivered"]');
      if (!orderedNode || !readyNode || !deliveredNode) return;

      this.holidays = this.dataset.holidays.split(',').filter(Boolean);
      const orderedDate = this.getOrderDate();
      orderedNode.textContent = this.formatDate(orderedDate);
      if (this.dataset.preorderDatePending === 'true') return;

      let readyDate = this.addEligibleDays(orderedDate, Number(this.dataset.fulfillmentDays), this.isBusinessDay);
      const preorderDate = this.parseDate(this.dataset.preorderShippingDate);
      if (preorderDate) {
        readyDate = new Date(Math.max(preorderDate.getTime(), orderedDate.getTime()));
        while (!this.isBusinessDay(readyDate)) {
          readyDate.setDate(readyDate.getDate() + 1);
        }
      }
      const deliveredDate = this.addEligibleDays(readyDate, Number(this.dataset.deliveryDays), this.isDeliveryDay);
      readyNode.textContent = this.formatDate(readyDate);
      deliveredNode.textContent = this.formatDate(deliveredDate);
    }

    parseDate(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
      const [year, month, day] = value.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      return this.formatDateKey(date) === value ? date : null;
    }

    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return day + '/' + month + '/' + year;
    }

    formatDateKey(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    isHoliday(date) {
      return this.holidays.includes(this.formatDateKey(date));
    }

    isBusinessDay(date) {
      const day = date.getDay();
      return day !== 0 && day !== 6 && !this.isHoliday(date);
    }

    isDeliveryDay(date) {
      return date.getDay() !== 0 && !this.isHoliday(date);
    }

    addEligibleDays(startDate, daysToAdd, validator) {
      const currentDate = new Date(startDate);
      let addedDays = 0;

      while (addedDays < daysToAdd) {
        currentDate.setDate(currentDate.getDate() + 1);
        if (validator.call(this, currentDate)) {
          addedDays += 1;
        }
      }

      return currentDate;
    }

    getOrderDate() {
      const now = new Date();
      const orderDate = new Date(now);
      orderDate.setHours(0, 0, 0, 0);

      if (now.getHours() >= Number(this.dataset.cutoffHour) || !this.isBusinessDay(orderDate)) {
        do {
          orderDate.setDate(orderDate.getDate() + 1);
        } while (!this.isBusinessDay(orderDate));
      }

      return orderDate;
    }

    });
  }
  } catch(e) { console.error(e); }
})();

})();
